<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    let answerStatus = {"1":"正确","0":"错误"};
    let examType = {"1":"专业考试","0":"初级考试"};

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
      mounted(){

      },
        methods: {
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${Url.examPractice.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if("新增"==clickName){
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(Url.examPractice.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
              ids:'',
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                    { title: '主键', field: 'id',hidden:true},
                      { title: '试题所属', field: 'examType',type:2,optionList:examType,isNumber:true},
                      { title: '关联问题内容', field: 'questions',textType:"textarea"},
                      { title: '答案一', field: 'answerOne'},
                      { title: '是否正确', field: 'answerOneResult',type:3,optionList:answerStatus,isNumber:true,data:0},
                      { title: '答案二', field: 'answerTwo'},
                      { title: '是否正确', field: 'answerTwoResult',type:3,optionList:answerStatus,isNumber:true,data:0},
                      { title: '答案三', field: 'answerThree'},
                      { title: '是否正确', field: 'answerThreeResult',type:3,optionList:answerStatus,isNumber:true,data:0},
                      { title: '正确回答奖励', field: 'rewardMoney',type:7,precision:2},
                      { title: '解析', field: 'parsing',textType:"textarea"},
                    ]
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                      { title: '题目', field: 'questions'},
                        {click:"查询"},
                        {click:"新增"},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.examPractice.query,
                    selection: true,
                    sequence: true,
                  method:"get",
                    cols: [
                      { title: '试题类型', field: 'examType',type:2,render:(data)=>{
                          return examType[data];
                        }},
                      { title: '试题内容', field: 'questions'},
                      { title: '体验金奖励', field: 'rewardMoney'},
                        { title: '最后操作时间', field: 'updateTime'},
                        {title:"操作",btnClick:[
                          {
                            name:"编辑",click:"update",type:"primary",icon: "el-icon-edit"
                          },
                            {
                              name:"删除",click:"delete",type:"primary",icon:"el-icon-delete"
                            }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
